import { Button } from "@/components/ui/button";
import { CreditCard, Landmark, Wallet } from "lucide-react";

const bankAvailable = (club) => !!club?.bank_debit_enabled && ["USD", "GBP", "EUR", "AUD"].includes((club?.currency || "USD").toUpperCase());

// SphereHyx charges no platform fee — the payer only covers Stripe's own processing fee, so the club nets the full amount.
const estStripe = (amount, method) => method === "bank" ? Math.min(amount * 0.008 + 0.25, 5) : amount * 0.029 + 0.3;
export const surchargeFor = (club, amount, method) => +estStripe(amount, method).toFixed(2);

// Payment buttons ordered cheapest-first: wallet (fee-free) > bank debit > card.
export function PayOptions({ club, amount, onPay, paying, compact = false, testId = "pay", walletBalance = null }) {
  const cur = club?.currency || "USD";
  const bank = bankAvailable(club);
  const walletOk = walletBalance != null && walletBalance + 1e-6 >= amount;
  const cardExtra = surchargeFor(club, amount, "card");
  const bankExtra = surchargeFor(club, amount, "bank");
  const fmt = (n) => `${cur} ${n.toFixed(2)}`;
  const size = compact ? "sm" : "default";
  const base = compact ? "" : "w-full h-12 text-base";
  return (
    <div className={compact ? "flex flex-col sm:flex-row flex-wrap gap-2" : "space-y-2"} data-testid={`${testId}-options`}>
      {walletOk && (
        <Button size={size} onClick={() => onPay("wallet")} disabled={!!paying} className={`${base} bg-emerald-600 hover:bg-emerald-700 text-white border-0`} data-testid={`${testId}-wallet-btn`}>
          <Wallet size={compact ? 14 : 17} className="mr-1.5" />
          {paying === "wallet" ? "Paying..." : compact ? `Balance · no fee` : `Pay from balance · ${fmt(amount)} (no fees)`}
        </Button>
      )}
      {bank && (
        <Button size={size} onClick={() => onPay("bank")} disabled={!!paying} className={`${base} brand-gradient text-white border-0 hover:opacity-90`} data-testid={`${testId}-bank-btn`}>
          <Landmark size={compact ? 14 : 17} className="mr-1.5" />
          {paying === "bank" ? "Redirecting..." : compact ? `Bank · lowest fee${bankExtra ? ` +${fmt(bankExtra)}` : ""}` : `Pay by bank debit${bankExtra ? ` · ${fmt(amount + bankExtra)}` : ""}`}
        </Button>
      )}
      <Button size={size} variant={bank ? "outline" : undefined} onClick={() => onPay("card")} disabled={!!paying} className={`${base} ${bank ? "border-border" : "brand-gradient text-white border-0 hover:opacity-90"}`} data-testid={`${testId}-card-btn`}>
        <CreditCard size={compact ? 14 : 17} className="mr-1.5" />
        {paying === "card" ? "Redirecting..." : compact ? `Card${cardExtra ? ` +${fmt(cardExtra)}` : ""}` : `Pay by card${cardExtra ? ` · ${fmt(amount + cardExtra)}` : ""}`}
      </Button>
      {!compact && (
        <p className="text-[11px] text-muted-foreground text-center" data-testid={`${testId}-surcharge-note`}>
          {bank ? "Bank debit is the cheapest option. " : ""}Only Stripe's processing fee is added — your club receives the full amount.{bank ? " Bank payments take 3–5 business days to settle." : ""}
        </p>
      )}
    </div>
  );
}
